const ArchiveChangelogStatic = () => {
    return (
      <>
        <div class="card-container">
            <div class="title-wrap-rainbow2">
                <h2>Hellscape Digital - Full Site Changelog</h2>
            </div>            
            <div>

            <h3>
                May 26, 2025 - v1.2
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong><br/><br/>
                        <ul>
                            <li>
                                <a href="/anjuonline/music/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>ANJU Online!</strong> - 2 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>DJ Sets</i></li>
                                    <ul>
                                        <li>&bull; Meauxminy @ Club Kawaii (Hosted by ANJU Online!)</li>
                                    </ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; ANJU Online! - Away Message</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>Kawaii Ry</strong> - 1 new release added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry - March 2nd II (prod. slugwurf)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/lugosi/all">
                                    &bull; <strong>Lugosi</strong> - 4 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; girlinmyphone 2 (feat. riley west) (prod. notamachine)</li>
                                        <li>&bull; bile&toxins (prod. secre)</li>
                                        <li>&bull; bile&toxins $$$(prod. secre)</li>
                                        <li>&bull; bile&toxins ^^^(prod. secre)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/meauxminy/all">
                                    &bull; <strong>Meauxminy</strong> - 1 new release added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>DJ Sets</i></li>
                                    <ul>
                                        <li>&bull; Meauxminy @ Club Kawaii (Hosted by ANJU Online!)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; <strong>Notamachine</strong> - 9 new releases
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; ideas, nowhere</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; intro</li>
                                        <li>&bull; #1</li>
                                        <li>&bull; #2</li>
                                        <li>&bull; #3</li>
                                        <li>&bull; reveal</li>
                                        <li>&bull; all my &#x3C;3</li>
                                        <li>&bull; nostalgia's dream</li>
                                        <li>&bull; headache, slow down</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Lugosi - girlinmyphone 2 (feat. riley west) (prod. notamachine)</li>
                                    </ul>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

                       <h3>
                August 29, 2025 - v1.1.1
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong><br/><br/>
                        <ul>
                            <li>
                                <a href="/anjuonline/music/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>ANJU Online!</strong> - 2 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>DJ Sets</i></li>
                                    <ul>
                                        <li>&bull; ANJU Online! - Deeply Online (Full Set)</li>
                                    </ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; ANJU Online! - I Uhhhhh</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>Kawaii Ry</strong> - 25 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; Visions</li>
                                    </ul>
                                    <li>&bull; <i>Music Videos</i></li>
                                    <ul>
                                        <li>&bull; Sometimes (I Know) (prod. Meauxminy)</li>
                                    </ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry & Meauxminy - Rocker Drip</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Real Movers</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - High Shelf</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Visions</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Sometimes (I Know)</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Evil World</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Super Vibes & Uber Rides</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Chop Talk</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Best Alive</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Dance With Me</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Smokescreen</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - RP</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Knives Out</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Glory</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Now We're Talkin'</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Lil' Bit</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Biggest Bim</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Meauxminy Speaks</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Wendy's at MCO</li>
                                        <li>&bull; So Close (prod. notamachine)</li>
                                        <li>&bull; So Close (Fast) (prod. notamahcine)</li>
                                        <li>&bull; Not Kawaii (prod. AY!JD)</li>
                                        <li>&bull; Super Powers (prod. 33nimb & frozy)</li>
                                    </ul>
                                    <li>&bull; <i>Features</i></li>
                                    <ul>
                                        <li>&bull; notamachine - dancer Pt. 2 (feat. Kawaii Ry)</li>
                                        <li>&bull; notamachine - broken (feat. Kawaii Ry & rileylol)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/lugosi/all">
                                    &bull; <strong>Lugosi</strong> - 21 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>EPs</i></li>
                                    <ul>
                                        <li>&bull; ninth circle</li>
                                        <li>&bull; her lips were poison but so were mine (prod. jolst)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; happy again (prod. jolst & pekarot)</li>
                                        <li>&bull; clean (prod. frevel)</li>
                                        <li>&bull; hunter (prod. yunny goldz)</li>
                                        <li>&bull; holdmedown interlude v3 (prod. 1080PALE)</li>
                                        <li>&bull; mean it (prod. irby & jolst)</li>
                                        <li>&bull; girlinmyphone</li>
                                        <li>&bull; girlinmyphone [NIGHTCORE]</li>
                                        <li>&bull; girlinmyphone [slowed+reverb]</li>
                                        <li>&bull; upmyprice (prod. notamachine & starsmp3)</li>
                                        <li>&bull; upmyprice [NIGHTCORE]</li>
                                        <li>&bull; 6FEET</li>
                                        <li>&bull; worse</li>
                                        <li>&bull; frän fine (9) [NIGHTCORE]</li>
                                        <li>&bull; BLOW</li>
                                        <li>&bull; higher</li>
                                        <li>&bull; rental (prod. jolst)</li>
                                        <li>&bull; snow (prod. jolst)</li>
                                        <li>&bull; pressure (steez) (prod. jolst)</li>
                                        <li>&bull; save that (prod. jolst)</li>
                                        <li>&bull; firefly (prod. jolst)</li>
                                        <li>&bull; allurpain (prod. cl6udy & jolst)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/meauxminy/all">
                                    &bull; <strong>Meauxminy</strong> - 19 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry & Meauxminy - Rocker Drip</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Real Movers</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - High Shelf</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Visions</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Sometimes (I Know)</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Evil World</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Super Vibes & Uber Rides</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Chop Talk</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Best Alive</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Dance With Me</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Smokescreen</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - RP</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Knives Out</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Glory</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Now We're Talkin'</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Lil' Bit</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Biggest Bim</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Meauxminy Speaks</li>
                                        <li>&bull; Kawaii Ry & Meauxminy - Wendy's at MCO</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Josen - DOUBLEDOWN (prod. Meauxminy)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/josen/all">
                                    &bull; <strong>Josen</strong> - 12 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; FDB2T (prod. notamachine)</li>
                                        <li>&bull; SCAT (prod. notamachine)</li>
                                        <li>&bull; HAT 2 DA SIDE (prod. Lux)</li>
                                        <li>&bull; iAiNTPASSiNDAROCK (prod. Apartment9)</li>
                                        <li>&bull; DATDEUCE (prod. Rich illuminati & notamachine)</li>
                                        <li>&bull; GLOCK40 (prod. Apartment9)</li>
                                        <li>&bull; TAKEAHIT (prod. Lux)</li>
                                        <li>&bull; DOUBLEDOWN (prod. meauxminy)</li>
                                        <li>&bull; 2DOE FREESTYLE (prod. notamachine)</li>
                                        <li>&bull; BIG JURRASIK (prod. Dani, bbuggin & Citgo)</li>
                                        <li>&bull; BALENCi22 (prod. Geist)</li>
                                        <li>&bull; ACTIVATE</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; <strong>Notamachine</strong> - 30 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; dreaming while swimming</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>EPs</i></li>
                                    <ul>
                                        <li>&bull; dreaming while drowning</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; dreaming</li>
                                        <li>&bull; nobody</li>
                                        <li>&bull; reserved</li>
                                        <li>&bull; dancer Pt. 2 (feat. Kawaii Ry)</li>
                                        <li>&bull; swimming</li>
                                        <li>&bull; dex's interlude (feat. Baredex)</li>
                                        <li>&bull; broken (feat. Kawaii Ry & rileylol)</li>
                                        <li>&bull; eyes</li>
                                        <li>&bull; going</li>
                                        <li>&bull; wake up</li>
                                        <li>&bull; morning</li>
                                        <li>&bull; wave to shore and maybe they'll see you</li>
                                        <li>&bull; counting sheep</li>
                                        <li>&bull; steam of unconsciousness</li>
                                        <li>&bull; notes on a wurli</li>
                                        <li>&bull; deteriorate</li>
                                        <li>&bull; standby / and wait</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Lugosi - girlinmyphone (prod. notamachine)</li>
                                        <li>&bull; Lugosi - girlinmyphone [NIGHTCORE] (prod. notamachine)</li>
                                        <li>&bull; Lugosi - girlinmyphone [slow+reverb] (prod. notamachine)</li>
                                        <li>&bull; Lugosi - upmyprice (prod. notamachine)</li>
                                        <li>&bull; Lugosi - upmyprice [NIGHTCORE] (prod. notamachine)</li>
                                        <li>&bull; Josen - FDB2T (prod. notamachine)</li>
                                        <li>&bull; Josen - SCAT (prod. notamachine)</li>
                                        <li>&bull; Josen - DATDEUCE (prod. notamachine)</li>
                                        <li>&bull; Kawaii Ry - So Close (prod. notamachine)</li>
                                        <li>&bull; Kawaii Ry - So Close (Fast) (prod. notamachine)</li>
                                        <li>&bull; Josen - 2DOE FREESTYLE (prod. notamachine)</li>
                                        <li>&bull; Tomali - 4NARCHY (feat. Ptown) (prod. notamachine)</li>
                                        <li>&bull; Tomali - Northbeach (feat. Ptown & Swamiii) (prod. notamachine)</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/semaj/all">
                                    &bull; <strong>Semaj</strong> - 5 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>EPs</i></li>
                                    <ul>
                                        <li>&bull; 1611</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Hide Away</li>
                                        <li>&bull; LOV3</li>
                                        <li>&bull; Crossed the Line</li>
                                        <li>&bull; Winds of Time</li>
                                        <li>&bull; You Know I Did It</li>
                                    </ul>
                                </ul>
                            </li>
                            <br/><br/>
                            <li>
                                <a href="/rileylol/all">
                                    &bull; <strong>rileylol</strong> - 4 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; the glass *remix* *2021* (prod. Uglyboy)</li>
                                        <li>&bull; most hated *2021* (prod. Baredex)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Features</i></li>
                                    <ul>
                                        <li>&bull; notamachine - broken (feat. Kawaii Ry & rileylol)</li>
                                        <li>&bull; YNG Spike - SOS (feat. rileylol)</li>
                                    </ul>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>    

            <h3>
                November 14, 2024 - v1.1.0
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>NEW MEMBER!</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/lildujour/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Lil Dujour has officially joined Hellscape Digital - showcase article coming soon to the blog
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/lildujour/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Full Lil Dujour discography (91 releases) added to music archive
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/videos/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 16 Lil Dujour videos added to music videos archive
                                </a>
                            </li>
                        </ul>
                    </li>
                    <br/>
                    <li>
                        <strong>&bull; <i>New Features</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/lildujour/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong><i>Community</i></strong> tab added to navigation
                                </a>
                                <ul>
                                    <li>
                                        <a href="https://hellscapedigital.net/lildujour/all" target="_blank;" rel="noopener noreferrer">
                                            &bull; (Experimental) Chat feature added to site - test it out and come say hi!
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a href="https://hellscapedigital.net/videos/all" target="_blank;" rel="noopener noreferrer">
                                            &bull; Hellscape Discord server is now open, invite portal added to site
                                        </a>
                                    </li> */}
                                    <li>
                                        <a href="/">
                                            &bull; Blog section placeholder created, now in active development
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <br/>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/anjuonline/music/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>ANJU Online!</strong> - 5 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Music Videos</i></li>
                                    <ul>
                                        <li>&bull; ANJU Online! - Katy</li>
                                    </ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; ANJU Online! - Rave Tool</li>
                                    </ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry - Catalyst (prod. ANJU Online!)</li>
                                        <li>&bull; Kawaii Ry - Catalyst (prod. ANJU Online!)</li>
                                    </ul>
                                    <li>&bull; <i>DJ Sets</i></li>
                                    <ul>
                                        <li>&bull; Hellscape Digital Vol. 6 (Hosted by ANJU Online!)</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; <strong>Kawaii Ry</strong> - 169 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; I Cry, I Bleed</li>
                                        <li>&bull; The Drop Off</li>
                                        <li>&bull; BLEEZY SEAZY IV</li>
                                        <li>&bull; Space Quest</li>
                                        <li>&bull; BLEEZY SEAZY V</li>
                                    </ul>
                                    <li>&bull; <i>EPs</i></li>
                                    <ul>
                                        <li>&bull; Green Dot</li>
                                    </ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Long Dark Road (prod. Saint Mike)</li>
                                        <li>&bull; Good Intentions (prod. jp)</li>
                                        <li>&bull; Tired (prod. Curtain)</li>
                                        <li>&bull; Tailgate (prod. Semaj)</li>
                                        <li>&bull; Better Way (prod. gotti & 1montemarko)</li>
                                        <li>&bull; Get Right (feat. Tristan Martin) (prod. ifeelvoid)</li>
                                        <li>&bull; Chanel Rings (prod. Semaj)</li>
                                        <li>&bull; God Complex (prod. notamachine)</li>
                                        <li>&bull; Love is Dead (prod. notamachine, antar & 1wireshark)</li>
                                        <li>&bull; One Time (prod. Semaj)</li>
                                        <li>&bull; Me 2 (prod. bleachh)</li>
                                        <li>&bull; Blessing (prod. Era)</li>
                                        <li>&bull; Rolling Up (prod. Jang)</li>
                                        <li>&bull; Stab My Back (prod. Rome)</li>
                                        <li>&bull; Up 2 You (prod. Treyvonne)</li>
                                        <li>&bull; Acoustic High (feat. Remy3D)</li>
                                        <li>&bull; I Did (prod. gotti & antar)</li>
                                        <li>&bull; I'm Drunk & Feel Like Sosa (prod. Semaj)</li>
                                        <li>&bull; Plus Six (prod. domboi)</li>
                                        <li>&bull; Uh-Huh (prod. geekinz)</li>
                                        <li>&bull; The Price (prod. Foreigner2x)</li>
                                        <li>&bull; 9 (prod. creedmakinnoise)</li>
                                        <li>&bull; Problem Solved (prod. Semaj)</li>
                                        <li>&bull; I'm Serious (prod. Zann Scott)</li>
                                        <li>&bull; I Cry, I Bleed (prod. Semaj)</li>
                                        <li>&bull; Bobby & Whitney (prod. Ross Gossage)</li>
                                        <li>&bull; Bump Bump (prod. Semaj)</li>
                                        <li>&bull; Pants Up (prod. gotti)</li>
                                        <li>&bull; Rollback (prod. Semaj)</li>
                                        <li>&bull; On One (prod. Jang)</li>
                                        <li>&bull; Catalyst (prod. ANJU Online!)</li>
                                        <li>&bull; Feelings In a Blunt (feat. Jackie Platinum) (prod. Ezy)</li>
                                        <li>&bull; Hideout (feat. Boy Floss)</li>
                                        <li>&bull; Late (feat. Lil Dujour) (prod. Meauxminy & notamachine)</li>
                                        <li>&bull; Dear Momma (prod. Jang)</li>
                                        <li>&bull; Don't Be Mad (feat. Lil Dujour) (prod. Leesta)</li>
                                        <li>&bull; ICU (feat. Lil Dujour) (prod. Leesta)</li>
                                        <li>&bull; Scarface (feat. Boy Floss) (prod. Leesta)</li>
                                        <li>&bull; How 2 Deal (prod. Leesta)</li>
                                        <li>&bull; I Don't Wanna Know What It Feels Like (prod. gotti)</li>
                                        <li>&bull; Rockstar Wasted (prod. gotti & notamachine)</li>
                                        <li>&bull; Your Hand In Mind (prod. starsmp3)</li>
                                        <li>&bull; Hope You Don't (prod. Rich Illuminati & notamachine)</li>
                                        <li>&bull; Fill Up (prod. Rich Illuminati)</li>
                                        <li>&bull; On One, Off Two (prod. Vorni)</li>
                                        <li>&bull; Get It & Go (prod. gotti & says6x)</li>
                                        <li>&bull; Falling In Love (I Didn't Know) (feat. Remy3D) (prod. Treyvonne)</li>
                                        <li>&bull; CK 2 Real Soon... (prod. Daria St. Clair)</li>
                                        <li>&bull; CG FEST 2023 (FREESTYLE) (prod. Foreigner2x)</li>
                                        <li>&bull; March 2nd (prod. ANJU Online!)</li>
                                        <li>&bull; Eye On You (prod. Calcinha)</li>
                                        <li>&bull; No Luck II (prod. Foreigner2x)</li>
                                        <li>&bull; HTR (prod. Foreigner2x)</li>
                                        <li>&bull; FEMA (prod. Foreigner2x)</li>
                                        <li>&bull; 2 Teas (prod. Theuzz011)</li>
                                        <li>&bull; Know They Mad (prod. Theuzz011)</li>
                                        <li>&bull; M7 (prod. gotti & mafiosaucedup)</li>
                                        <li>&bull; Ledger Stax (prod. starsmp3)</li>
                                        <li>&bull; Mind Freak (prod. gotti)</li>
                                        <li>&bull; True Stitch (prod. gotti & 1montemarko)</li>
                                        <li>&bull; Barqs (prod. gotti & maniii)</li>
                                        <li>&bull; Truie Talk (prod. gotti + gmk)</li>
                                        <li>&bull; Red Cups (feat. Boy Floss)</li>
                                        <li>&bull; Security (feat. Boy Floss)</li>
                                        <li>&bull; Chris Brown & Young Thug (Go Crazy) (Kawaii Ry Remix)</li>
                                        <li>&bull; See Me This Weekend (prod. AY!JD)</li>
                                        <li>&bull; On The Run (prod. AY!JD)</li>
                                        <li>&bull; Buddha Man (prod. Meauxminy)</li>
                                        <li>&bull; That Classic Kawaii (prod. chris6lair & Rio Leyva)</li>
                                        <li>&bull; Hard Rock (prod. chris6lair)</li>
                                        <li>&bull; Bleezy Seazy (prod. chris6lair & Rio Leyva)</li>
                                        <li>&bull; Remember A Time (prod. chris6lair & jibaorockin)</li>
                                        <li>&bull; Didn't Expect (prod. chris6lair & rayfromiburu)</li>
                                        <li>&bull; BK Seazy (prod. chris6lair & bkthebagman)</li>
                                        <li>&bull; What About My Ops? (prod. chris6lair & Rio Leyva)</li>
                                        <li>&bull; Buddha Buckle (prod. chrislair & Rio Leyva)</li>
                                        <li>&bull; Rockstar Bit (prod. chris6lair & Rio Leyva)</li>
                                        <li>&bull; Push (prod. chris6lair & 1gokami)</li>
                                        <li>&bull; Damn! (prod. chris6lair)</li>
                                        <li>&bull; Truant (prod. chris6lair)</li>
                                        <li>&bull; Got Mail (prod. chris6lair & toobears)</li>
                                        <li>&bull; Packie (prod. chris6lair & toobears)</li>
                                        <li>&bull; Q (prod. chris6lair & bkthebagman)</li>
                                        <li>&bull; KiKi in Paris (prod. chris6lair, starborn & m0riss)</li>
                                        <li>&bull; Hero (prod. chris6lair)</li>
                                        <li>&bull; GLOW (prod. chris6lair)</li>
                                        <li>&bull; Cave Diving (prod. chris6lair & Rio Leyva)</li>
                                        <li>&bull; Deer Lease (prod. chris6lair & imastarborn)</li>
                                        <li>&bull; Bleezy Mindset (prod. chris6lair, TF & bad.technique)</li>
                                        <li>&bull; Sum Fye (prod. chris6lair & TF)</li>
                                        <li>&bull; Bad Habits (prod. chris6lair & TF)</li>
                                        <li>&bull; Hellscape Z (prod. chris6lair & bkthebagman)</li>
                                        <li>&bull; Goin' Electric (prod. chris6lair & morecalcium)</li>
                                        <li>&bull; Burger Boy (prod. chris6lair)</li>
                                        <li>&bull; Output (prod. chris6lair, 1gokami & themed1c)</li>
                                        <li>&bull; Diablo (prod. chris6lair & TF)</li>
                                        <li>&bull; Damn, I Got a Lot (prod. chris6lair & venexxi)</li>
                                        <li>&bull; Bloodhounds (prod. chris6lair & TF)</li>
                                        <li>&bull; Not Televised (prod. chris6lair)</li>
                                        <li>&bull; Bigger Bag (prod. chris6lair & TF)</li>
                                        <li>&bull; One In the Chamber (prod. chris6lair & TF)</li>
                                        <li>&bull; Tea Time w Bleezy (prod. chris6lair & itsexo)</li>
                                        <li>&bull; Weatherman (prod. chris6lair)</li>
                                        <li>&bull; My Year (prod. Baredex)</li>
                                        <li>&bull; Don't Know Why (prod. Baredex)</li>
                                        <li>&bull; Lightswitch (prod. Baredex & Remy3D)</li>
                                        <li>&bull; WWYD (prod. Baredex)</li>
                                        <li>&bull; Space Quest (prod. Baredex)</li>
                                        <li>&bull; Drain Gang (prod. Baredex)</li>
                                        <li>&bull; Heart (prod. Baredex)</li>
                                        <li>&bull; Man Down (prod. Baredex)</li>
                                        <li>&bull; Forever Bright (prod. Baredex)</li>
                                        <li>&bull; Disguise (prod. Baredex)</li>
                                        <li>&bull; Don't Ask (prod. Baredex)</li>
                                        <li>&bull; Can't Leave Me Behind Yet (prod. Baredex)</li>
                                        <li>&bull; Freethrow (prod. Baredex)</li>
                                        <li>&bull; Too Rare (prod. Baredex)</li>
                                        <li>&bull; Jackpot (prod. Baredex)</li>
                                        <li>&bull; I Know The Feeling (prod. Baredex)</li>
                                        <li>&bull; Looker (prod. Baredex)</li>
                                        <li>&bull; Feelin' the Fire (prod. Baredex)</li>
                                        <li>&bull; Step, Flex (prod. Baredex)</li>
                                        <li>&bull; Shoe Box (prod. Baredex)</li>
                                        <li>&bull; Tension (prod. Baredex)</li>
                                        <li>&bull; Hold The Key (prod. Waves2.0)</li>
                                        <li>&bull; Disenchantment (prod. chris6lair)</li>
                                        <li>&bull; Turn a New Page (prod. chris6lair)</li>
                                        <li>&bull; Chronobreak (prod. chris6lair & desertpunk)</li>
                                        <li>&bull; Said I Wouldn't Drink (prod. chris6lair & jibaorockin)</li>
                                        <li>&bull; Hard 2 Forget (prod. chris6lair & jibaorockin)</li>
                                        <li>&bull; Fall Back (prod. chris6lair)</li>
                                        <li>&bull; GG Baby (prod. chris6lair & TF)</li>
                                        <li>&bull; Protect My Heart (prod. chris6lair & 36ix)</li>
                                        <li>&bull; Favorite Girl (prod. chris6lair & jibaorockin)</li>
                                        <li>&bull; DALYDK (prod. chris6lair & notamachine)</li>
                                        <li>&bull; Dearly (prod. chris6lair)</li>
                                        <li>&bull; Photo Attachments (prod. chris6lair)</li>
                                        <li>&bull; Talk On (prod. chris6lair)</li>
                                        <li>&bull; Ain't Nun New (prod. chris6lair & TF)</li>
                                        <li>&bull; Yeah, You (prod. chris6lair)</li>
                                        <li>&bull; See Me (prod. chris6lair)</li>
                                        <li>&bull; Rocket Pop (prod. chris6lair & TF)</li>
                                        <li>&bull; TRY & Kawaii (feat. TRYFG) (prod. chris6lair & bkthebagman)</li>
                                        <li>&bull; Aww Whatever (prod. chris6lair)</li>
                                        <li>&bull; Always Go (prod. chris6lair & TF)</li>
                                        <li>&bull; More Praise (prod. chris6lair & TF)</li>
                                        <li>&bull; Destonia (2D) (prod. chris6lair)</li>
                                        <li>&bull; WTSA (prod. chris6lair)</li>
                                        <li>&bull; Can't Stop It (prod. chris6lair)</li>
                                        <li>&bull; They Not (prod. chris6lair & TF)</li>
                                        <li>&bull; Perfect Product (prod. chris6lair & TF)</li>
                                        <li>&bull; Make Sure (prod. chris6lair)</li>
                                        <li>&bull; Round 4 Round (prod. chris6lair & bkthebagman)</li>
                                        <li>&bull; Red Ball (prod. chris6lair & macrazy)</li>
                                        <li>&bull; Draw The Lines (prod chris6lair & macrazy)</li>
                                        <li>&bull; Shock Val (prod. chris6lair)</li>
                                        <li>&bull; Lil Durk - Habit (Kawaii Ry Remix)</li>
                                    </ul>
                                    <li>&bull; <i>Features</i></li>
                                    <ul>
                                        <li>&bull; STICK GOD - RUNNIN' (feat. Kawaii Ry)</li>
                                        <li>&bull; zx sallow - realest steezer (feat. Kawaii Ry)</li>
                                        <li>&bull; chris6lair - Strawberry (feat. Kawaii Ry & scumboi)</li>
                                        <li>&bull; 8ngelonline - Ecstasy (feat. Kawaii Ry & woes)</li>
                                        <li>&bull; zx sallow - steez of the year (feat. Kawaii Ry & Lexik)</li>
                                        <li>&bull; TRYFG - 0__00 куплю рюкзак хелло китти!! 0__00 (feat. Kawaii Ry)</li>
                                        <li>&bull; kn1febaby - Forreal (feat. Kawaii Ry)</li>
                                        <li>&bull; Lil Dujour - If Its Me Or U Its Me Every Time (feat. Kawaii Ry)</li>
                                        <li>&bull; zx sallow & Nate Hollow - Carrying K's (feat. Kawaii Ry)</li>
                                        <li>&bull; zx sallow & Nate Hollow - United Nations (feat. Kawaii Ry)</li>
                                        <li>&bull; Lil Dujour & Kawaii Ry - Conceited</li>
                                        <li>&bull; Lil Dujour & Kawaii Ry - This My Last One But I Can Break It Down In Half</li>
                                        <li>&bull; Lugosi - g00fy bitch free$tyle (prod. Kawaii Ry)</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/lugosi/all">
                                    &bull; <strong>Lugosi</strong> - 11 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; DYING ON THE EAST COAST</li>
                                        <li>&bull; Hellborne</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; goinoutsadv2 (prod. notamachine)</li>
                                        <li>&bull; truey on truey (prod. trunks & thislandis)</li>
                                        <li>&bull; paranoid (prod. jolst, ertu & wasterr)</li>
                                        <li>&bull; goinoutsad (prod. jolst & thislandis)</li>
                                        <li>&bull; burn holes (prod. notamachine & rjpasin)</li>
                                        <li>&bull; tragic (prod. jolst & 5head)</li>
                                        <li>&bull; throughtherain (prod. ugly beats)</li>
                                        <li>&bull; kill 4 you (prod. jolst & 5head)</li>
                                        <li>&bull; g00fy bitch free$tyle (prod. Kawaii Ry)</li>
                                        <li>&bull; bulletproof (prod. Jolst)</li>
                                        <li>&bull; hone$tly (prod. Meauxminy)</li>
                                        <li>&bull; WHATSINYOCUP (prod. OhMyGon!)</li>
                                        <li>&bull; frän fine (9) (prod. itsmefouzy)</li>
                                        <li>&bull; nerd$ rope (prod. Jolst)</li>
                                        <li>&bull; kino der toten (feat. Newalias) (prod. kagayaki)</li>
                                        <li>&bull; u$ v3 (prod. Jolst)</li>
                                        <li>&bull; on g0d (feat. Boy Floss) (prod. itsmefouzy)</li>
                                        <li>&bull; $tre$$ (feat. Lil Dujour) (prod. Ugly Beats)</li>
                                        <li>&bull; $creamin%%% (prod. Ugly Beats)</li>
                                        <li>&bull; big (die tonight) (prod. shinju & taylor morgan)</li>
                                        <li>&bull; rice (prod. bygadriel)</li>
                                        <li>&bull; bad bitch (feat. baby osama) (prod. Wintfye)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Features</i></li>
                                    <ul>
                                        <li>&bull; notamachine - enjoy yourself (feat. Kawaii Ry & Lugosi)</li>
                                        <li>&bull; zx sallow & Nate Hollow - Sacrifice (feat. Lugosi) (prod. Gmanz)</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/meauxminy/all">
                                    &bull; <strong>Meauxminy</strong> - 6 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry - Late (feat. Lil Dujour) (prod. Meauxminy & notamachine)</li>
                                        <li>&bull; Kawaii Ry - Buddha Man (prod. Meauxminy)</li>
                                        <li>&bull; Lugosi - hone$tly (prod. Meauxminy)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>DJ Sets</i></li>
                                    <ul>
                                        <li>&bull; DUBSCAPE (Full Set)</li>
                                        <li>&bull; Sunday in CK</li>
                                        <li>&bull; Sunday in CK 2</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/josen/all">
                                    &bull; <strong>Josen</strong> - 54 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Albums</i></li>
                                    <ul>
                                        <li>&bull; Plugg On Drill Street</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Fuck Again (feat. Kawaii Ry)</li>
                                        <li>&bull; Air it out</li>
                                        <li>&bull; CallMyPhone</li>
                                        <li>&bull; GLOCKY</li>
                                        <li>&bull; TRAPINDAMAIL</li>
                                        <li>&bull; Wraith</li>
                                        <li>&bull; BACKHOME FREESTYLE</li>
                                        <li>&bull; DaPack!</li>
                                        <li>&bull; PercyInMySystem</li>
                                        <li>&bull; KICKINHEROUT</li>
                                        <li>&bull; SCRAPINDAPOT HARAMBE TRIBUTE</li>
                                        <li>&bull; TWINGLOCK</li>
                                        <li>&bull; OG BOBBY JOSEN FREESTYLE</li>
                                        <li>&bull; MOCKINGBIRD ALICE VIP (w/ Alice333)</li>
                                        <li>&bull; PUSH and KICK</li>
                                        <li>&bull; HowDaFuq (HellscapeMageekerz)</li>
                                        <li>&bull; 4INDALEAN</li>
                                        <li>&bull; Denim</li>
                                        <li>&bull; NEVABORIN</li>
                                        <li>&bull; Stereo Love (feat. POPSTARBILLS & Braxton Knight)</li>
                                        <li>&bull; LET ME TALK MA SHIT</li>
                                        <li>&bull; MY DRAWZ!</li>
                                        <li>&bull; 200 DYCKMAN 2 MIAMI (feat. Loudpack Kap)</li>
                                        <li>&bull; BOOMIN IN MIAMI</li>
                                        <li>&bull; PROJEKTBABY 2024</li>
                                        <li>&bull; IWALKINTHISBITCHLIKEIMICESPICE (prod. QueueUpNext & Gemstone)</li>
                                        <li>&bull; Peja Stojakvic (feat. Zazbourne)</li>
                                        <li>&bull; OGlockyAutoPartz (prod. Rich Illuminati)</li>
                                        <li>&bull; No Bluff (prod. QueueUpNext)</li>
                                        <li>&bull; Plug Dreamin (prod. Apartment9)</li>
                                        <li>&bull; Let My Denim Sag (prod. Negative)</li>
                                        <li>&bull; PopOutDaKut (prod. Negative)</li>
                                        <li>&bull; WalkedInDisBitch (feat. RX Papi) (prod. Snoopo)</li>
                                        <li>&bull; Miles Morales (feat. Lil Xelly) (prod. Killguap)</li>
                                        <li>&bull; Drizzy Drill Rogers (feat. xellfromhell) (prod. Geeohs)</li>
                                        <li>&bull; Crash Out (prod. Negative)</li>
                                        <li>&bull; Actin Up (prod. Baredex & Apartment9)</li>
                                        <li>&bull; Plug Special (prod. Apartment9)</li>
                                        <li>&bull; KIRBY 2024 FREESTYLE (prod. prblm)</li>
                                        <li>&bull; HOW🤫 MANY 🤫GANGSTAS?!🤫 [1️⃣2️⃣3️⃣4️⃣] (prod. Brwnworld)</li>
                                        <li>&bull; JELLO (prod. Rich Illuminati)</li>
                                        <li>&bull; SUPERBAD LIKE MCLOViN2 (prod. QueueUpNext & 1brite)</li>
                                        <li>&bull; POKEMON ZAZA LEGENDS FREESTYLE (prod. Rich Illuminati)</li>
                                        <li>&bull; G17 (feat. Otaku God) (prod. Rich Illuminati)</li>
                                        <li>&bull; PAIR2MUCH (feat. DESTINY) (prod. dead2finesse)</li>
                                        <li>&bull; I HAD A LONG DAY I TELL A NIGGA TO STFU (prod. Taurs, Glokmane & Skreer)</li>
                                        <li>&bull; DenZelle (prod. Astral Trap)</li>
                                        <li>&bull; IWALKINDISBITCHLIKEIMERICDOA (prod. THEYLUVFLARE)</li>
                                        <li>&bull; JUMP IN DAT WATER LIKE A DOLPHIN (prod. Toju)</li>
                                        <li>&bull; #DONT #WIPE #YA #NOSE (feat. LUVREI)</li>
                                        <li>&bull; DRILLBOWSKI (prod. notamachine & Rich Illuminati)</li>
                                        <li>&bull; LETDAPHONERING</li>
                                        <li>&bull; ROADRUNNAH</li>
                                        <li>&bull; WAKEUPDENiGEEK (prod. notamachine)</li>
                                        <li>&bull; KOKAINE (feat. POPSTARBILLS)</li>
                                        <li>&bull; ON MY OWN</li>
                                        <li>&bull; GLOCK HIT LIKE DA INTERVENTION</li>
                                        <li>&bull; 🟢GREENDOT🟢(prod. 24KHRIS)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Features</i></li>
                                    <ul>
                                        <li>&bull; Miami Dave - Mobb (feat. Josen)</li>
                                        <li>&bull; DamienPRIE$T - New York Flex (feat. Josen) (prod. 730HAHAH)</li>
                                        <li>&bull; REROCK. - PICK A SIDE (feat. Josen)</li>
                                        <li>&bull; REROCK. - HOP OUT (feat. Josen)</li>
                                        <li>&bull; kn1febaby - Ws (feat. Josen)</li>
                                        <li>&bull; Ivanko - Hottest (feat. Josen)</li>
                                        <li>&bull; Gothnormie - NEMATODES (feat. Josen)</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; <strong>Notamachine</strong> - 23 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>EPs</i></li>
                                    <ul>
                                        <li>&bull; some remixes</li>
                                        <li>&bull; whispers: 2.0</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; fall</li>
                                        <li>&bull; lost in your eyessss:</li>
                                        <li>&bull; u got us:</li>
                                        <li>&bull; heart atk:</li>
                                        <li>&bull; someday:</li>
                                        <li>&bull; parallax:</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Placements</i></li>
                                    <ul>
                                        <li>&bull; Kawaii Ry - God Complex (prod. notamachine)</li>
                                        <li>&bull; Kawaii Ry - Love is Dead (prod. notamachine, antar & 1wireshark)</li>
                                        <li>&bull; Kawaii Ry - Late (feat. Lil Dujour) (prod. Meauxminy & notamachine)</li>
                                        <li>&bull; Kawaii Ry - Rockstar Wasted (prod. notamachine)</li>
                                        <li>&bull; Kawaii Ry - Hope You Don't (prod. Rich Illuminati & notamachine)</li>
                                        <li>&bull; Daria St. Clair - Pieces (prod. notamachine & ROHO)</li>
                                        <li>&bull; Lugosi - goinoutsadv2 (prod. notamachine)</li>
                                        <li>&bull; Lugosi - burn holes (prod. notamachine)</li>
                                        <li>&bull; Scum Boi - have no dreams (feat. kurtwarnermovie) (prod. notamachine, antar & wund)</li>
                                        <li>&bull; Kawaii Ry - DALYDK (prod. chris6lair & notamachine)</li>
                                        <li>&bull; CoryRay - 4 a Lifetime (feat. Rico Leone) (prod. notamachine)</li>
                                        <li>&bull; Josen - DRILLBOWSKI (prod. notamachine & Rich Illuminati)</li>
                                        <li>&bull; Josen - WAKEUPDENiGEEK (prod. notamachine)</li>
                                    </ul>
                                </ul>
                                <ul>
                                    <li>&bull; <i>Remixes</i></li>
                                    <ul>
                                        <li>&bull; Button Maker, billy ! & 1Booth - ENOUGH! (notamachine remix)</li>
                                        <li>&bull; blissom - so far (notamachine remix)</li>
                                        <li>&bull; internetboy - skin care (notamachine remix)</li>
                                        <li>&bull; Jedwill - placebo effect (notamachine remix)</li>
                                        <li>&bull; isid or - all the sounds (notamachine remix)</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/semaj/all">
                                    &bull; <strong>Semaj</strong> - 4 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; Love's Not Fair</li>
                                        <li>&bull; Stick By My Side</li>
                                        <li>&bull; Pick Up the Phone</li>
                                        <li>&bull; What I Do</li>
                                    </ul>
                                </ul>
                            </li>
                            <li>
                                <a href="/rileylol/all">
                                    &bull; <strong>rileylol</strong> - 9 new releases added to music archive
                                </a>
                                <ul>
                                    <li>&bull; <i>Singles</i></li>
                                    <ul>
                                        <li>&bull; size zero (prod. yogic & diem)</li>
                                        <li>&bull; just friends (prod. luvdakvsh)</li>
                                        <li>&bull; church st. (prod. nick nash & vlex)</li>
                                        <li>&bull; time zones (prod. grayskies)</li>
                                        <li>&bull; another life</li>
                                        <li>&bull; portland (prod. immortal)</li>
                                        <li>&bull; sixtyminutes (prod. antsy, supa & G06)</li>
                                        <li>&bull; petty (prod. drecyy)</li>
                                        <li>&bull; nothing more (prod. dead yami)</li>
                                    </ul>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <br/>
                    <li>
                        <strong>&bull; <i>Site Upgrades</i></strong>
                        <ul>
                            <li>
                                <a href="/">
                                    &bull; Navigation across the site has been revamped and overhauled to provide scalability and improved user experience
                                </a>
                            </li>
                            <li>
                                <a href="/">
                                    &bull; Redesigned navigation for both desktop and mobile versions
                                </a>
                            </li>
                            <li>
                                <a href="/">
                                    &bull; New site masthead which now displays version number
                                </a>
                            </li>
                            <li>
                                <a href="/">
                                    &bull; Page width on desktop increased approximately 20% to improve legibility
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                June 29, 2023 - v1.0.14.1
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://open.spotify.com/track/6JPdZVcrAGL1jrIbSYWwOQ?si=f6128fe2056e48d2" target="_blank;">
                                    &bull; Kawaii Ry, TRYFG & Boy Floss - Rare Link [Hellscape Exclusive]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                June 17, 2023 - v1.0.14
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/kawaiiry/albums">
                                    &bull; Kawaii Ry & chris6lair - BLEEZY SEAZY III [Album]
                                </a>
                            </li>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; sphere merchants - trust (prod. notamachine) [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/features">
                                    &bull; Kodak Black - New Girl (feat. Kawaii Ry) [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/albums">
                                    &bull; Kawaii Ry & notamachine - Alone Together [Album]
                                </a>
                            </li>
                            <li>
                                <a href="/semaj/all">
                                    &bull; Semaj - Keep Quiet [Single]
                                </a>
                            </li>
                            <li>
                                <a href="https://open.spotify.com/track/6XOdRRqu65ZxZJlNl72Bzm?si=0db04b58019a42c3">
                                    &bull; Kawaii Ry & Remy3D - Horseshoes and Buddhaman [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; Tomali & Ptown - BEN10 (prod. notamachine) [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; Tomali & Ptown - ALL4LUV (prod. notamachine) [Single]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                April 29, 2023 - v1.0.13
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/josen/all">
                                    &bull; Josen - Drill La Drill [Album]
                                </a>
                            </li>
                            <li>
                                <a href="/notamachine/all">
                                    &bull; notamachine - birdsongs [EP]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/features">
                                    &bull; Kawaii Ry - Slime Shawty 2 [Album]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                April 21, 2023 - v1.0.12
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/lugosi/all">
                                    &bull; Lugosi - PHOTO [Music Video]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Kawaii Ry - The Porch [EP]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/features">
                                    &bull; TRYFG - слэп!! (feat. Kawaii Ry) [Feature]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/features">
                                    &bull; TRYFG - hannah montana (feat. Kawaii Ry) [Feature]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/features">
                                    &bull; TRYFG - marilyn monroe! (feat. Kawaii Ry) [Feature]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                April 6, 2023 - v1.0.11
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/lugosi/all">
                                    &bull; Lugosi - BODY IN THE TRUNK [EP]
                                </a>
                            </li>
                            <li>
                                <a href="/josen/all">
                                    &bull; Josen - HollabackBoy (prod. Apartment9) [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Kawaii Ry - Special K (prod. Nextime) [Single]
                                </a>
                            </li>
                        </ul>
                    </li>
                    <br/>
                    <li>
                        <strong>&bull; <i>New Press</i></strong>
                        <ul>
                            <li>
                                    &bull; SHEF Radio Ep. 22 feat. Kawaii Ry (Full Interview)
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                April 1, 2023 - v1.0.10
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/hellscaperadio">
                                    &bull; Hellscape Radio Vol. 5 - Kawaii Ry @ CRACKFEST V (Full Set)
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Kawaii Ry & Lugosi - Bimmy Boys [Album]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                March 26, 2023 - v1.0.9
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Kawaii Ry - BLEEZY SEAZY II (prod. chrislair) [EP]
                                </a>
                            </li>
                            <li>
                                <a href="/josen/all">
                                    &bull; Heems - Take Me (The Heights) (feat. Josen) (prod. notamachine) [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/semaj/all">
                                    &bull; Semaj - Heartless [Single]
                                </a>
                            </li>
                            <li>
                                <a href="/rileylol/videos">
                                    &bull; Hyder Daze - idontwannaseeyou (feat. rileylol) [Video]
                                </a>
                            </li>
                        </ul>
                    </li>
                    <br/>
                    <li>
                        <strong>&bull; <i>Site Upgrades</i></strong>
                        <ul>
                            <li>
                                <a href="/videos/2023">
                                    &bull; Added 2023 filter for Music Videos
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                March 2, 2023 - v1.0.8
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/anjuonline/music/all">
                                    &bull; ANJU Online! - Solid State Memories [Album]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Kawaii Ry & Meauxiny - Meaux Money Less Talk [Album]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; Gotti - FURTHER (feat. Kawaii Ry) [Feature]
                                </a>
                            </li>
                            <li>
                                <a href="/kawaiiry/all">
                                    &bull; ReTread - BlueLabel (feat. Kawaii Ry) [Feature]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                February 23, 2023 - v1.0.7
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="/anjuonline/music/all">
                                    &bull; ANJU Online! - Technology [Single]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>&bull; <i>New Artwork</i></strong>
                        <ul>
                            <li>
                                <a href="/anjuonline/art/illustration">
                                    &bull; ANJU Online! - "Don't Be Shy" [Illustration; ETH 1/1]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                February 17, 2023 - v1.0.6
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/hellscaperadio" target="_blank;" rel="noopener noreferrer">
                                    &bull; Hellscape Radio Vol. 4 - Kawaii Ry & ANJU Online! @ CG Fest 2023
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p>

            <h3>
                February 1, 2023 - v1.0.5
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 01/31/23: Kawaii Ry - Club Kawaii [20 tracks]
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/josen/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 01/28/23: Josen - Drill La Drill (Intro) (prod. notamachine)
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/semaj/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 01/20/23: Semaj - All For Nothing
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                January 9, 2023 - v1.0.4
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>NEW MEMBER!</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/rileylol/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; rileylol has officially joined Hellscape Digital
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/rileylol/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Full rileylol discography (91 releases) added to music archive
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/videos/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 3 rileylol videos added to music videos archive
                                </a>
                            </li>
                        </ul>
                    </li>
                    <br></br>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/rileylol/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Full rileylol discography (91 releases) added to music archive
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/videos/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; 3 rileylol videos added to music videos archive
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                January 5, 2023 - v1.0.3
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/notamachine/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; notamachine - dont4getme (feat. Kawaii Ry)
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/notamachine/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Loudpak Shawty - Slow It Down (prod. notamachine)
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/semaj/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Semaj - Smile
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/semaj/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Semaj - Worth It
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/semaj/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Semaj - Only For Tonight
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                January 3, 2023 - v1.0.2
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - Last Weekend (prod. notamachine & Joe Leytrick)
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - Glo Baby LP [7 tracks]
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - Make Your World EP (prod. Jang) [3 tracks]
                                </a>
                            </li>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - Flip That (prod. Culoso)
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                December 8, 2022 - v1.0.1
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://hellscapedigital.net/kawaiiry/all" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - USED 2 THE HATE EP (prod. notamachine) [7 tracks]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                December 3, 2022 - v1.0.0
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://youtu.be/0PDDyumLrYo" target="_blank;" rel="noopener noreferrer">
                                    &bull; ANJU Online! & Kawaii Ry - SWAG SUPPLIER (feat. STARINTHESKY) [Music Video]
                                </a>
                            </li>
                        </ul>
                        <strong><br/>&bull; <i>Milestone</i></strong>
                        <ul>
                            <li>
                                <a href="https://youtu.be/0PDDyumLrYo" target="_blank;" rel="noopener noreferrer">
                                    &bull; Hellscape Digital site released publically! 
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                December 1, 2022
            </h3> 
            <p class="changelogtext"> 
                <ul>
                    <li>
                        <strong>&bull; <i>New Music</i></strong>
                        <ul>
                            <li>
                                <a href="https://soundcloud.com/kawaiiry/sets/bleezy-seazy" target="_blank;" rel="noopener noreferrer">
                                    &bull; Kawaii Ry - BLEEZY SEAZY VOL. 1 (prod. Chris6lair) [EP]
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </p> 

            <h3>
                    November 30, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; Kawaii Ry - KiKi Crazy (prod. Meauxminy)</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

            <h3>
                    November 29, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; Kawaii Ry - Can't Believe (prod. notamachine & prodmitchell1)</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

            <h3>
                    November 28, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; Kawaii Ry - Smokin' Ganj In The Saint Laurent (prod. notamachine, depart & lodoni)</li>
                                    <li>&bull; Kawaii Ry - Army Stick (prod. gotti)</li>
                                    <li>&bull; Kawaii Ry - Eleven (prod. notamachine, nightmare & freezepop)</li>
                                    <li>&bull; Kawaii Ry - Flaw(less) (prod. ezy)</li>
                                    <li>&bull; Kawaii Ry - Häagen-Dazs (prod. ezy)</li>
                                    <li>&bull; Button Maker, 1booth & billy ! - ENOUGH! (notamachine Remix)</li>
                                    <li>&bull; chet - need ur luv (prod. Chris6lair & notamachine)</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

            <h3>
                    November 21, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                <li>&bull; Kawaii Ry - Trunk (prod. malloy)</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

                <h3>
                    November 20, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                <li>&bull; Kawaii Ry - Fruity Pebbles (prod. notamachine, depart & dynoxmusic)</li>
                                <li>&bull; Kawaii Ry - It Happened (prod. Pand)</li>
                                <li>&bull; Lugosi - LUGOSI LP (9 tracks)</li>
                                <li>&bull; Lugosi - BREAKING UP (prod. notamachine & Gotti)</li>
                                <li>&bull; Josen - LEAVIN EM STUCK' w/ REROCK! (prod. REROCK / mashup by Geist)</li>
                                <li>&bull; Josen - LOLLIPOP (prod. TONTO)</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                <li>&bull; Albums page added to Lugosi archive</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

                <h3>
                    November 19, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                <li>&bull; Homepage UX updated - added archive section and footer</li>
                                <li>&bull; Updated site title and browser icon</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 

                <h3>
                    November 18, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; ANJU Online & Kawaii Ry - Mr. Drill / pist off</li>
                                    <li>&bull; Lugosi - ghostsinthewalls (Music Video)</li>
                                    <li>&bull; 19 Kawaii Ry singles added to music archive</li>
                                    <li>&bull; 1 Remy3D placement added to music archive</li>
                                    <li>&bull; 3 notamachine placement added to music archive</li>
                                    <li>&bull; 2 Semaj placements added to music archive</li>
                                    <li>&bull; 5 Meauxminy placements added to music archive</li>
                                </ul>
                            </li>
                        </ul> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Artwork</i></strong>
                                <ul>
                                    <li>&bull; 41 Cloudi Daze illustrations added to artwork archive</li>
                                    <li>&bull; 1 ANJU Online! illustration added to artwork archive</li>
                                </ul>
                            </li>
                        </ul>   
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; Cloudi Daze portfolio reinstated to artwork archive</li>
                                    <li>&bull; Placements page added to Remy3D archive</li>
                                </ul>
                            </li>
                        </ul> 
                    </p> 
                <h3>
                    September 17, 2022
                </h3> 
                    <p class="changelogtext"> 
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music Video</i></strong>
                                <ul>
                                <li>&bull; Josen - ZA</li>
                                </ul>
                            </li>
                        </ul>
                    </p> 
                <h3>
                    September 16, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                <li>&bull; Kawaii Ry - Executive EP (4 songs)</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>New Artwork</i></strong>
                                <ul>
                                    <li>&bull; 18 ANJU Online! illustrations added to artwork archive</li>
                                    <li>&bull; 4 ANJU Online! mixed media works added to artwork archive</li>
                                    <li>&bull; 1 ANJU Online! design added to artwork archive</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; Added Mixed Media category to ANJU Online! artwork archive</li>
                                    <li>&bull; Added additional navigation from "Latest" homepage elements to their respective archives</li>
                                </ul>
                            </li>
                        </ul>  
                    </p> 
                <h3>
                    September 15, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Artwork</i></strong>
                                <ul>
                                    <li>&bull; 17 ANJU Online! illustrations added to artwork archive</li>
                                    <li>&bull; 3 ANJU Online! designs added to artwork archive</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; ANJU Online! artwork archive look & feel has been revamped</li>
                                    <li>&bull; Cloudi Daze artwork archive temporarily removed for maintenance</li>
                                </ul>
                            </li>
                        </ul>  
                    </p> 
                <h3>
                    September 14, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; Kawaii Ry - one left EP (2 songs)</li>
                                    <li>&bull; 8 Semaj singles added to music archive</li>
                                    <li>&bull; 2 notamachine placements added to music archive</li>
                                    <li>&bull; 1 Kawaii Ry feature added to music archive</li>
                                </ul>
                            </li>
                        </ul> 
                        <ul>
                            <strong>&bull; <i>Site Upgrades</i></strong>
                            <ul>
                                <li>&bull; Hellscape Radio archive look & feel has been revamped</li>    
                                <li>&bull; Fixed visual error on /music page</li>
                                <li>&bull; Fixed navigation error on /videos/all page</li>
                            </ul>
                        </ul>  
                    </p> 
                <h3>
                    September 13, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; 75 Semaj placements added to music archive</li>
                                    <li>&bull; 2 notamachine placements added to music archive</li>
                                    <li>&bull; 1 Kawaii Ry feature added to music archive</li>
                                </ul>
                            </li>
                        </ul> 
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; Added Semaj discography to music archive</li>
                                    <li>&bull; Added Music Videos category to music archive</li>
                                    <li>&bull; Added Videos category to ANJU Online! music archive</li>
                                    <li>&bull; Added year filter to ANJU Online! music archive</li>
                                    <li>&bull; Fixed labelling of 4 notamachine songs</li>
                                </ul>
                            </li>
                        </ul> 
                    </p>   
                <h3>
                    September 12, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; 9 Remy3D songs added to music archive</li>
                                    <li>&bull; 3 Kawaii Ry features added to music archive</li>
                                    <li>&bull; 1 Lugosi feature added to music archive</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; Added Remy3D discography to music archive</li>
                                    <li>&bull; Fixed broken navigation in Lugosi archive</li>
                                </ul>
                            </li>
                        </ul>  
                    </p>    
                <h3>
                    September 11, 2022
                </h3> 
                    <p class="changelogtext">
                        <ul>
                            <li>
                                <strong>&bull; <i>New Music</i></strong>
                                <ul>
                                    <li>&bull; 118 Josen songs added to music archive</li>
                                    <li>&bull; 75 notamachine songs added to music archive</li>
                                    <li>&bull; 2 Meauxminy songs added to music archive</li>
                                </ul>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <strong>&bull; <i>Site Upgrades</i></strong>
                                <ul>
                                    <li>&bull; Added Site Changelog to Archive page</li>
                                    <li>&bull; Fixed broken navigation in Meauxminy archive</li>
                                </ul>
                            </li>
                        </ul> 
                    </p>            
            </div>
        </div>    
      </>
    );
  };
  export default ArchiveChangelogStatic;